
import { Vue, Options } from "vue-class-component";
import { playerGroupsModule } from "@/store/modules/player-groups.module";

@Options({
  beforeRouteEnter: async (to, from, next) => {
    await playerGroupsModule.load(to.params.id as string);
    next();
  },
})
export default class PlayerGroupPageComponent extends Vue {
  get group() {

    let { SvtAppVersion } = playerGroupsModule.item as {id: string, SvtAppVersion: string}
    SvtAppVersion = SvtAppVersion != undefined ? SvtAppVersion : '0.0'

    return {...playerGroupsModule.item, SvtAppVersion};
  }

  save() {
    const { SvtAppVersion } = this.group
    playerGroupsModule.updateGroupDoc({ SvtAppVersion })
  }
}
